import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex h-fit justify-between gap-4',
    addToCart: 'flex-1 2xl:min-w-94',
    wishlist: 'flex-center flex size-[50px]',
    wishlistIcon: 'size-6 md:size-8'
  }
});
